import { connect } from 'react-redux'
import { GoogleMap, withGoogleMap, withScriptjs } from 'react-google-maps'
import { arrayOf, element, func, shape, string } from 'prop-types'
import React from 'react'
import defaultMapOptions from '../../../defaultMapOptions'
import getVenuesSettings from '../../../getVenuesSettings'
import VenueMarker from './VenueMarker'
import { retainState } from '../../../actions/app'
import { mapWasClicked, venueMarkerWasClicked } from '../../../actions/map'

const venuesSettings = getVenuesSettings()
const key = venuesSettings.googleMapsKey

const MapViewMap = withScriptjs(withGoogleMap(props => (
  <GoogleMap
    defaultCenter={{ lat: 40, lng: 0 }}
    defaultOptions={defaultMapOptions}
    defaultZoom={2}
    onClick={props.mapWasClicked}
  >
    {props.venues.map((venue) => {
      if (venue.latitude === null || venue.longitude === null) {
        return null
      }
      return (
        <VenueMarker
          isOpen={props.openMarker === venue._id}
          key={venue._id}
          retainState={props.retainState}
          venue={venue}
          venueMarkerWasClicked={props.venueMarkerWasClicked}
        />
      )
    })}
  </GoogleMap>
)))
MapViewMap.defaultProps = {
  containerElement: <div style={{ height: '100%' }} />,
  googleMapURL: `https://maps.googleapis.com/maps/api/js?key=${key}&v=3.exp`,
  loadingElement: <div style={{ height: '100%' }} />,
  mapElement: <div style={{ height: '100%' }} />,
  openMarker: null,
}
MapViewMap.propTypes = {
  containerElement: element.isRequired,
  googleMapURL: string.isRequired,
  loadingElement: element.isRequired,
  mapElement: element.isRequired,
  mapWasClicked: func.isRequired,
  retainState: func.isRequired,
  venueMarkerWasClicked: func.isRequired,
  venues: arrayOf(shape({})).isRequired,
}

const mapStateToProps = state => ({
  openMarker: state.map.openMarker,
  venues: state.venue.venues,
})

export default connect(mapStateToProps, {
  mapWasClicked,
  retainState,
  venueMarkerWasClicked,
})(MapViewMap)
